// extracted by mini-css-extract-plugin
export default {"svg":"agents_svg__TS7pA","buttons":"agents_buttons__6bB+Z"};